import http from "../http-common";

class CorreoService {

    ingresar(data) {
        return http.post("/correo",data);
    }

    getAll() {
        return http.get("/correo");
    }

    delete(id) {
        return http.delete(`/correo/${id}`);
    }

    getById(id) {
        return http.get(`/correo/${id}`);
    }

    update(id, data) {
        return http.put(`/correo/${id}`, data);
    }
}

export default new CorreoService();